import { BasicList, New } from 'components'
import { parse, addDays, isBefore } from 'date-fns'
import useModal from 'hook/useModal'
// css
import 'assets/style/common.scss'

export default function MenuRecipKnow({ dataList = [] }) {
  const { openFramePopup } = useModal()

  /**
   * HTML 태그 제거
   * @param {string} cn
   * @returns
   */
  const removeHtmlTags = (cn) => {
    let div = document.createElement('div')
    div.innerHTML = cn
    return div.innerText
  }

  /**
   * 신규게시물 아이콘 확인
   * @param {string} regDate
   * @returns
   */
  const checkNewFlag = (regDate) => {
    const weekBefore = addDays(new Date(), -7)
    const regDt = parse(regDate, 'yyyy.MM.dd', new Date())
    return isBefore(weekBefore, regDt)
  }

  return (
    <>
      {/* 김정웅: title옆 n아이콘 추가, description 추가, category 컬러 css*/}
      {dataList.length > 0 ? (
        <BasicList
          className="mt16"
          data={dataList.map((item) => {
            return {
              id: item.ntcAtclId,
              title: (
                <>
                  {item.ttl}
                  {checkNewFlag(item.regDate) ? <New /> : ''}
                </>
              ),
              description: removeHtmlTags(item.cn),
              category: `[${item.operDvsnNm}]`,
              date: item.regDate,
              commentCount: item.cmntCnt,
            }
          })}
          onClick={(item) => openFramePopup(`/know/menuoper/${item.id}`, '메뉴운영노하우')}
        ></BasicList>
      ) : (
        <div className="flex-1 flex-align-center" style={{ marginTop: '40px' }}>
          <div className="flex-col flex-item-center">
            <span className="icon-message-gray"></span>
            <p className="c-6 mt24">등록된 노하우가 없습니다. </p>
          </div>
        </div>
      )}
    </>
  )
}
